module.exports = __webpack_public_path__ + "media/assets/iPhone_frame-b189386bb669d6b1f1aa8f824957cc37.svg";